module.exports = __webpack_public_path__ + "static/media/3-Ways-To-Get-FREE-Car-Removal-Service-640x400.20a7f762.jpg";